<script lang="ts" setup>
if (isEmpty(useGetSubdomain()))
  navigateTo('', { redirectCode: 301 })
</script>

<template>
  <CompaniesDirectory route-key="A" />
</template>
